import { getPivotRaw as t } from "../three/index11.js";
function n(r) {
  return [
    t([0, 0, 0], r),
    t([1, 0, 0], r),
    t([1, 0, 1], r),
    t([0, 0, 1], r)
  ];
}
export {
  n as getLocalCorners
};
//# sourceMappingURL=index10.js.map
